<template>
  <div
    :class="{'paginator--blur': scrollTop >= 5}"
    class="paginator"
    :style="{'width': paginatorWidth + 'px'}"
  >
    <button
      class="paginator__load-more"
      :disabled="!newsFeedStore.hasMore || newsFeedStore.loading"
      @click="loadMore"
    >
      {{ newsFeedStore.loading
        ? t('news_page_pagination.loading')
        : t('news_page_pagination.load_more') }}
    </button>
    <div class="paginator__total-message">
      {{ (newsFeedStore.items?.length || 0) + ' / ' + newsFeedStore.totalCount }}
    </div>
  </div>
</template>

<script setup>
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";
import { t } from "@/controllerLK/AvalLocalization";
import { defineProps, onBeforeUnmount, ref, toRef, watch } from "vue";

const props = defineProps({
  container: {
    type: [Object, null],
    required: true
  }
});

const newsFeedStore = useNewsFeedStore();
const container = toRef(props, "container");

// Расчет ширины пагинатора под разный масштаб
const paginatorWidth = ref(0);
let ro;

// Расчет скролла для наложения блюра на пагинатор
const scrollTop = ref(0);

const onScroll = (e) => {
  const el = e.target || e;
  scrollTop.value = el.scrollHeight - el.scrollTop - el.clientHeight;
};

watch(container, (el, prev) => {
  if (prev && ro) ro.disconnect();
  if (el) {
    ro = new ResizeObserver(([entry]) => {
      const raw = entry.contentRect.width;
      const roundedUp = Math.ceil(raw * 100) / 100;
      paginatorWidth.value = parseFloat(roundedUp.toFixed(2));
    });
    ro.observe(el);
  }
}, { immediate: true });

watch(container, (el, prev) => {
  if (prev) prev.removeEventListener("scroll", onScroll);
  if (el) {
    onScroll(el);
    el.addEventListener("scroll", onScroll, { passive: true });
  }
}, { immediate: true });

onBeforeUnmount(() => {
  ro?.disconnect();
});

// Курсорная пагинация — только «вперёд». По клику подгружаем следующую страницу
// и аппендим карточки к текущему списку.
const loadMore = async () => {
  await newsFeedStore.loadMoreNews();
};
</script>
<style lang="scss" scoped>
.paginator {
  position: absolute;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  color: var(--text-text-pur);
  gap: 10px;
  bottom: 0;

  &--blur {
    background: linear-gradient(180deg, transparent 0%, var(--background-01) 100%);
    box-shadow: 0 -5px 7px 0 #7090B014;
    backdrop-filter: blur(6px);
  }

  &__load-more {
    height: 30px;
    padding: 0 14px;
    border-radius: 8px;
    background: var(--background-bg-white);
    color: var(--text-text-pur);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;

    &:hover:not(:disabled) {
      background: var(--background-bg-hover);
    }

    &:disabled {
      opacity: 0.5;
      cursor: default;
    }
  }

  &__total-message {
    font-size: 13px;
    color: var(--text-text-pur);
    cursor: default;
  }
}
</style>
